import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { Link, useParams } from "react-router-dom";
import { db } from "../firebase";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";

export default function PieceDetailsPage() {
  const { slug } = useParams();
  const [piece, setPiece] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const fetchPiece = async () => {
      try {
        const q = query(
          collection(db, "pieces_detachees"),
          where("enLigne", "==", true)
        );
        const snap = await getDocs(q);
        const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        const found = all.find((p) => p.slug === slug);
        setPiece(found || null);

        if (found) {
          const similar = all
            .filter((p) => p.id !== found.id && p.categorie === found.categorie)
            .slice(0, 4);
          setRelated(similar);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchPiece();
  }, [slug]);

  const whatsappLink = useMemo(() => {
    if (!piece) return "#";
    const phone = (piece.contactWhatsApp || "+22879309400").replace(/\D/g, "");
    const msg = `Bonjour, je suis intéressé par cette pièce : ${piece.nom} (${piece.reference || "sans référence"}). Pouvez-vous me donner plus d’informations ?`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  }, [piece]);

  if (!piece) {
    return (
      <>
        <MenuNav />
        <MobileMenu />
        <div className="container py-5 text-center">
          <div className="alert alert-light border">Pièce introuvable.</div>
        </div>
      </>
    );
  }

  return (
    <>
      <MenuNav />
      <MobileMenu />

      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-6">
            <img
              src={piece.imageUrls?.[0] || "/assets/default.jpg"}
              alt={piece.nom}
              className="img-fluid rounded shadow-sm w-100"
              style={{ maxHeight: "500px", objectFit: "cover" }}
            />
          </div>

          <div className="col-lg-6">
            <div className="d-flex flex-wrap gap-2 mb-3">
              {piece.isPromo && <span className="badge bg-danger">Promo</span>}
              {piece.isPopular && (
                <span className="badge bg-warning text-dark">Populaire</span>
              )}
              {piece.isFeatured && (
                <span className="badge bg-primary">Vedette</span>
              )}
            </div>

            <h1 className="fw-bold">{piece.nom}</h1>
            <p className="text-muted">
              {piece.categorie} • {piece.marque}
            </p>

            <h3 className="text-primary fw-bold mb-3">
              {piece.prix > 0
                ? `${Number(piece.prix).toLocaleString("fr-FR")} FCFA`
                : "Prix sur demande"}
            </h3>

            <div className="mb-3">
              <strong>Référence :</strong> {piece.reference || "—"}
            </div>
            <div className="mb-3">
              <strong>État :</strong> {piece.etat || "—"}
            </div>
            <div className="mb-3">
              <strong>Disponibilité :</strong> {piece.disponibilite || "—"}
            </div>
            <div className="mb-3">
              <strong>Stock :</strong> {piece.stock || 0}
            </div>
            <div className="mb-3">
              <strong>Compatibilité :</strong>{" "}
              {Array.isArray(piece.modeleCompatible) && piece.modeleCompatible.length > 0
                ? piece.modeleCompatible.join(", ")
                : "Non précisée"}
            </div>

            <p className="text-muted">{piece.description}</p>

            <div className="d-flex flex-wrap gap-3 mt-4">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success"
              >
                Contacter sur WhatsApp
              </a>
              <a
                href="tel:+22879309400"
                className="btn btn-outline-dark"
              >
                Appeler THE BRIDGE
              </a>
            </div>
          </div>
        </div>

        {related.length > 0 && (
          <div className="mt-5">
            <h3 className="fw-bold mb-4">Pièces similaires</h3>
            <div className="row g-4">
              {related.map((item) => (
                <div key={item.id} className="col-6 col-md-3">
                  <div className="card h-100 shadow-sm border-0">
                    <img
                      src={item.imageUrls?.[0] || "/assets/default.jpg"}
                      alt={item.nom}
                      className="card-img-top"
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                    <div className="card-body">
                      <h6 className="fw-bold">{item.nom}</h6>
                      <p className="text-primary fw-bold small">
                        {item.prix > 0
                          ? `${Number(item.prix).toLocaleString("fr-FR")} FCFA`
                          : "Prix sur demande"}
                      </p>
                      <Link
                        to={`/piece/${item.slug}`}
                        className="btn btn-outline-primary btn-sm w-100"
                      >
                        Voir
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
